/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Search icon.
 */
export const ICON_CAPABILITY_SEARCH = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.3652 16.058L27.43 34.2834C25.8764 36.8727 22.1236 36.8727 20.57 34.2834L9.63478 16.058C8.03513 13.3919 9.95558 10 13.0648 10H34.9352C38.0444 10 39.9649 13.3919 38.3652 16.058Z"
      fill="#1D9BE2"
    />
    <path
      clipRule="evenodd"
      d="M3.25503 17.5312C-0.268591 11.5472 4.04575 4 10.9901 4H18.4238C19.2786 4 19.9715 4.69291 19.9715 5.54767C19.9715 6.40242 19.2786 7.09533 18.4238 7.09533H10.9901C6.44035 7.09533 3.61371 12.0401 5.9223 15.9606L18.9273 38.0462C21.2018 41.909 26.7887 41.9089 29.063 38.046L32.7341 31.8108C33.1678 31.0742 34.1164 30.8287 34.853 31.2624C35.5896 31.696 35.8351 32.6447 35.4015 33.3813L31.7304 39.6164C28.259 45.5124 19.7317 45.5126 16.26 39.6168L3.25503 17.5312ZM28.0194 5.54767C28.0194 4.69291 28.7123 4 29.567 4H37.0099C43.9518 4 48.2665 11.5425 44.7477 17.5265L40.9165 24.0419C40.4832 24.7788 39.5347 25.0248 38.7979 24.5916C38.0611 24.1583 37.815 23.2098 38.2483 22.473L42.0795 15.9575C44.3849 12.037 41.5581 7.09533 37.0099 7.09533H29.567C28.7123 7.09533 28.0194 6.40242 28.0194 5.54767Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);

/**
 * Search icon (dark).
 */
export const ICON_CAPABILITY_SEARCH_DARK = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.3652 16.058L27.43 34.2834C25.8764 36.8727 22.1236 36.8727 20.57 34.2834L9.63478 16.058C8.03513 13.3919 9.95558 10 13.0648 10H34.9352C38.0444 10 39.9649 13.3919 38.3652 16.058Z"
      fill="#707070"
    />
    <path
      clipRule="evenodd"
      d="M3.25503 17.5312C-0.268591 11.5472 4.04575 4 10.9901 4H18.4238C19.2786 4 19.9715 4.69291 19.9715 5.54767C19.9715 6.40242 19.2786 7.09533 18.4238 7.09533H10.9901C6.44035 7.09533 3.61371 12.0401 5.9223 15.9606L18.9273 38.0462C21.2018 41.909 26.7887 41.9089 29.063 38.046L32.7341 31.8108C33.1678 31.0742 34.1164 30.8287 34.853 31.2624C35.5896 31.696 35.8351 32.6447 35.4015 33.3813L31.7304 39.6164C28.259 45.5124 19.7317 45.5126 16.26 39.6168L3.25503 17.5312ZM28.0194 5.54767C28.0194 4.69291 28.7123 4 29.567 4H37.0099C43.9518 4 48.2665 11.5425 44.7477 17.5265L40.9165 24.0419C40.4832 24.7788 39.5347 25.0248 38.7979 24.5916C38.0611 24.1583 37.815 23.2098 38.2483 22.473L42.0795 15.9575C44.3849 12.037 41.5581 7.09533 37.0099 7.09533H29.567C28.7123 7.09533 28.0194 6.40242 28.0194 5.54767Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
